import React, { useEffect, useState } from "react";
import './App.css';

function App() {


  const [advice,setAdvice] = useState('');


  useEffect (()=>{
    fetchAdvice();
  },[])
  

  const fetchAdvice = async() => {
    
    const response = await fetch('https://api.adviceslip.com/advice');
    const data = await response.json();
    console.log(data.slip.advice);
    setAdvice(data.slip.advice);

  }

  return (
    
      <div className="app">
        <div className="card">
          <h1 className="heading">{advice}</h1>
          <button className="button" onClick={fetchAdvice}>
            <span>GIVE ME ADVICE !</span>
          </button>
        </div>
      </div>
      
      
      

  );
}

export default App;
